/**
 * API request/response types
 */
import { z } from 'zod';
// Sourcing pipeline
export const SourcingRequestSchema = z.object({
    customerId: z.string().uuid(),
    jobId: z.string().uuid(),
    criteria: z.object({
        skills: z.array(z.string()).optional(),
        experience: z.number().optional(),
        location: z.string().optional(),
    }).optional(),
});
//# sourceMappingURL=api.js.map